
const Books = [

{ 
    title: 'French Park',
    author: 'Eric Cocoletzi',
    img: 'https://m.media-amazon.com/images/I/71a4n1ZQ2uL.jpg',
    category: 'coco',
    buy:'https://www.amazon.com/FRENCH-PARK-Eric-Cocoletzi-ebook/dp/B0C4ZRT74T/ref=sr_1_1?crid=ELOD78CL4I4L&keywords=french+park+cocoletzi&qid=1688060672&sprefix=french+park+cocoletzi%2Caps%2C308&sr=8-1',
    id: 1,
    
},
    
{
    title: 'The Book of Freedom: Exit the Simulation',
    author: 'Keexzus',
    img: 'https://m.media-amazon.com/images/I/41-Ii9NlK1L.jpg',
    category: 'keex',
    buy:'https://www.amazon.com/Book-Freedom-Exit-Simulation-ebook/dp/B07HTZJYVJ/ref=sr_1_1?crid=1TYGUSJH4T6NT&keywords=book+of+freedom+keexzus&qid=1688063058&sprefix=book+of+freedom+keexzus%2Caps%2C207&sr=8-1',
    id: 2, 
    
},

{
    title: 'Light One On and Pop One Open',
    author: 'Eric Cocoletzi',
    img: 'https://m.media-amazon.com/images/I/416B6UaQC-L._SX331_BO1,204,203,200_.jpg',
    category: 'coco',
    buy:'https://www.amazon.com/Light-One-Pop-Open-ebook/dp/B0C42XT1LQ/ref=sr_1_1?crid=JYAXD9L44JYS&keywords=cocoletzi&qid=1688063142&sprefix=cocoletzi%2Caps%2C170&sr=8-1',
    id: 3,
    
},

{
    title: "Someplace I've Never Been To, But Would Like To Someday",
    author: 'Eric Cocoletzi',
    img: 'https://m.media-amazon.com/images/I/41RF16ePK-L._SX331_BO1,204,203,200_.jpg',
    category: 'coco',
    buy:'https://www.amazon.com/Someplace-Never-Been-Would-Someday-ebook/dp/B0C4ZXBJ9D/ref=sr_1_1?crid=1VCN7S3SUBCFT&keywords=eric+cocoletzi+someplace&qid=1688063186&sprefix=eric+cocoletzi+someplace%2Caps%2C177&sr=8-1',
    id: 4,
    
},

{
    title: 'Might as Well',
    author: 'Eric Cocoletzi',
    img: 'https://m.media-amazon.com/images/I/61FYu7TcwtS._AC_UY436_FMwebp_QL65_.jpg',
    category: 'coco',
    buy:'https://www.amazon.com/MIGHT-AS-WELL-Eric-Cocoletzi-ebook/dp/B0C4JG27LM/ref=sr_1_fkmr0_1?crid=1VCN7S3SUBCFT&keywords=eric+cocoletzi+someplace&qid=1688063231&sprefix=eric+cocoletzi+someplace%2Caps%2C177&sr=8-1-fkmr0',
    id: 5,
},

{
    title: 'They Say Animals Can Take Care of Themselves',
    author: 'Eric Cocoletzi',
    img: 'https://m.media-amazon.com/images/I/81sLJMV9CYL._AC_UY436_FMwebp_QL65_.jpg',
    category: 'coco',
    buy:'https://www.amazon.com/They-Animals-Take-Care-Themselves-ebook/dp/B0C42VJZP3/ref=sr_1_1?crid=RLYQJ5DJV504&keywords=eric+cocoletzi+they+say+animals&qid=1688063272&sprefix=eric+cocoletzi+they+say+animals%2Caps%2C162&sr=8-1',
    id: 6,
}

];

export default Books; 